var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { space, width, alignItems, flexDirection, justifyContent, height, } from 'styled-system';
var NoAnimationBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  animation: none;\n  background: transparent !important;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  animation: none;\n  background: transparent !important;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), space, width, height, alignItems, flexDirection, justifyContent);
export default NoAnimationBox;
var templateObject_1;
